
import { defineComponent } from 'vue';

export default defineComponent({
  setup() {
    async function refresh() {
      if (window.location.href !== 'http://localhost:8080/no-status') {
        window.location.replace(process.env.VUE_APP_DOMAIN_URL as string);
      } else {
        window.location.replace('http://localhost:8080/');
      }
    }

    return {
      refresh,
    };
  },
});
